import { useMemo, Fragment } from 'react';
import { Divider } from '@cbhq/cds-web/layout';
import { Div, Text, LinkPressable } from '@cbhq/cdx-components';
import { getComposeEntryProps } from '../../../globals/composePage.js';
import { useContentfulMicrocopy } from '../../../globals/microcopy.js';
import { groupRelatedArticles } from './groupRelatedArticles.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function RelatedStories({
  articles
}) {
  const microcopies = useContentfulMicrocopy();
  const groupedArticles = useMemo(() => groupRelatedArticles(articles), [articles]);
  return /*#__PURE__*/jsxs(Div, {
    as: "aside",
    maxWidth: 320,
    spacingEnd: 2,
    spacingTop: 4,
    spacingStart: 6,
    spacingBottom: 2,
    flexDirection: "column",
    display: {
      sm: 'none',
      md: 'flex'
    },
    children: [/*#__PURE__*/jsx(Text, {
      variant: "legal",
      color: "foregroundMuted",
      spacingBottom: 2,
      children: microcopies.blog?.relatedStories
    }), groupedArticles && Object.entries(groupedArticles).map(([label, articles], index) => /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        children: [/*#__PURE__*/jsx(Text, {
          variant: "caption",
          color: "foregroundMuted",
          children: label.toUpperCase()
        }), articles && articles.map((article, index) => {
          const _getComposeEntryProps = getComposeEntryProps(article),
            headline = _getComposeEntryProps.headline,
            composeSlug = _getComposeEntryProps.composeSlug;
          return /*#__PURE__*/jsx(LinkPressable, {
            href: `/${composeSlug}`,
            children: /*#__PURE__*/jsx(Text, {
              variant: "body",
              spacingTop: 1,
              color: "foregroundMuted",
              children: headline
            })
          }, index);
        })]
      }), Object.keys(groupedArticles).length > index + 1 && /*#__PURE__*/jsx(Divider, {
        spacingVertical: 2
      })]
    }, label))]
  });
}
export { RelatedStories };
//# sourceMappingURL=RelatedStories.js.map
